<template>
    <v-container class="event-payment-confirm" v-if="paymentRecord" fluid>
        <HkiaraceBannerFrame :src="require('../../../assets/acc.jpg')"
                             :label="paymentSuccess ? $t('my_event_list.payment_success') : $t('my_event_list.payment_fail')">
            <v-container class="event-payment-confirm-content">
                <v-row v-if="paymentSuccess">
                    <v-col>
                        <v-row>
                            <v-col class="event-payment-success-title">
                                {{$t('my_event_list.summary')}}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field :label="$t('admin_hkiarace.event')"
                                              readonly
                                              hide-details
                                              :value="$sanitizeHtml(event.name)"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="event.signup_mode === 2">
                            <v-col>
                                <v-text-field :label="$t('event.session')"
                                              readonly
                                              hide-details
                                              :value="enrollment.session.name"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-if="event.signup_mode === 3">
                            <v-col>
                                <v-text-field :label="$t('event.series')"
                                              readonly
                                              hide-details
                                              :value="enrollment.series.name"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-textarea :label="$t('admin_enrollment.meta')"
                                            readonly
                                            hide-details
                                            auto-grow
                                            no-resize
                                            :rows="1"
                                            :value="enrollmentDetails"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-text-field :label="$t('my_event_list.pay_amount')"
                                              readonly
                                              hide-details
                                              :value="payAmount"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-btn color="primary"
                                       :to="{name: 'my-account', query: {t: 1}}">
                                    {{$t('finish')}}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row v-if="!paymentSuccess">
                    PAYMENT FAILED. PLEASE TRY AGAIN
                </v-row>
            </v-container>

        </HkiaraceBannerFrame>
    </v-container>
</template>

<script>
    import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";

    export default {
        name: 'EventPaymentConfirm',
        components: {HkiaraceBannerFrame},
        data() {
            return {
                paymentRecordId: this.$route.params.paymentRecordId,
                paymentRecord: null,
                enrollment: null,
            };
        },
        mounted() {
            this.getPaymentRecord();
        },
        computed: {
            paymentSuccess() {
                let paymentSuccess = false;
                if (this.paymentRecord.payment_record.payment_method === 'cyber_source') {
                    this.paymentRecord.payment_record.cyber_source_payment_records.forEach((r) => {
                        if (r.decision === 'ACCEPT') {
                            paymentSuccess = true;
                        }
                    })
                } else if (this.paymentRecord.payment_record.payment_method === 'union_pay') {
                    this.paymentRecord.payment_record.union_pay_payment_records.forEach((r) => {
                        if (r.response_code === '00') {
                            paymentSuccess = true;
                        }
                    })
                }

                return paymentSuccess;
            },
            event() {
                return this.paymentRecord.participant.event_session.event;
            },
            enrollmentDetails() {
                let v = this;
                let fee_tiers = JSON.parse(this.enrollment.event.fee_tiers);
                let meta = JSON.parse(this.enrollment.meta);

                let results = [];

                fee_tiers.forEach((t) => {
                    if (meta[t['id']]) {
                        results.push(v.$localeGet(t, 'name') + ': ' + meta[t['id']]);
                    }
                });

                return results.length > 0 ? results.join('\r') : '-';
            },
            payAmount() {
                let record = false;
                if (this.paymentRecord.payment_record.payment_method === 'cyber_source') {
                    this.paymentRecord.payment_record.cyber_source_payment_records.forEach((r) => {
                        if (r.decision === 'ACCEPT') {
                            record = r;
                        }
                    });

                    return record ? record.amount : '';
                } else if (this.paymentRecord.payment_record.payment_method === 'union_pay') {
                    this.paymentRecord.payment_record.union_pay_payment_records.forEach((r) => {
                        if (r.response_code === '00') {
                            record = r;
                        }
                    });

                    return record ? (record.amount / 100) : '';
                }
            },
        },
        methods: {
            getPaymentRecord() {
                this.$callAPI('hkiarace/event/my_payments/', {
                    record_id: this.paymentRecordId,
                }, function (response) {
                    this.paymentRecord = response.body.payment_record;
                    this.enrollment = response.body.enrollment;
                })
            },
        },
    }
</script>

<style lang="less">
    .event-payment-confirm {
        .event-payment-confirm-content {
            padding: 2rem;
            background-color: white;

            .event-payment-success-title {
                color: #8E765B;
                font-size: 1.2rem;
                font-weight: bold;
            }

            .v-label {
                color: #8E765B;
            }

            .v-text-field > .v-input__control > .v-input__slot:before {
                display: none;
            }

            .v-text-field > .v-input__control > .v-input__slot:after {
                display: none;
            }
        }
    }
</style>